import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ProcessAction } from '../../interfaces/process-action.interface';
import { ProcessEntry, ScreenActions } from '../../interfaces/screen-actions.interface';
import { TableConfig } from '../table/interfaces/table-config.interface';
import { floatingActionButtonAnimations } from './floating-action-button.animations';

@Component({
  selector: 'sellions-layout-renderer-floating-action-button',
  templateUrl: './floating-action-button.component.html',
  animations: floatingActionButtonAnimations,
})
export class FloatingActionButtonComponent implements OnChanges {
  @Input() config: TableConfig;
  @Input() screenActions: ScreenActions;
  @Output() clickedButton = new EventEmitter<ProcessAction>();

  mainButtonIcon = 'add';
  fabButtons: ProcessEntry[] = [];
  buttons = [];
  fabTogglerState = 'inactive';

  constructor() {}

  ngOnChanges(): void {
   this.fabButtons = this.getButtons();
   this.mainButtonIcon = this.getMainActionListIcon();
  }

  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab() {
    if (this.getButtons().length === 1) {
      this.onClick(0);
    } else {
      this.buttons.length && this.buttons.length > 0 ? this.hideItems() : this.showItems();
    }
  }

  onClick(index: number) {
    this.clickedButton.emit({process: this.getButtons()[index], element: null});
  }

  getButtons() {
    if(this.config && this.config.screenActions && this.config.screenActions.processList) {
      return this.config.screenActions.processList.filter((process) => !process.contextMenuVisible);
    } else if(this.screenActions && this.screenActions.processList) {
      return this.screenActions.processList.filter((process) => !process.contextMenuVisible);
    }

    return [];
  }

  getMainActionListIcon() {
    if(this.config && this.config.screenActions) {
      return this.getButtonIconFromScreenActions(this.config.screenActions);
    } else {
      return this.getButtonIconFromScreenActions(this.screenActions);
    }
  }

  private getButtonIconFromScreenActions(actions: ScreenActions) {
    if(actions.actionListIcon) {
      return actions.actionListIcon;
    } else if (actions.processList && actions.processList && actions.processList.length > 0) {
      return actions.processList[0].icon;
    }
  }

  hasAnyItems() {
    return this.getButtons().length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/floating-action-button/floating-action-button.component.ts